import { useMemo } from "react";
import BoardCanvas from "./BoardCanvas";
import { ASPECTS, TEMPLATES, buildTemplate } from "./templates";

export function AspectPicker({ value, onChange, compact = false }) {
  return (
    <div className={`mb-aspects${compact ? " is-compact" : ""}`} role="radiogroup" aria-label="Board size">
      {Object.entries(ASPECTS).map(([key, aspect]) => (
        <button
          key={key}
          type="button"
          role="radio"
          aria-checked={value === key}
          className={value === key ? "active" : ""}
          onClick={() => onChange(key)}
        >
          <span className="mb-aspect-shape" style={{ aspectRatio: `${aspect.ratio}` }} aria-hidden="true" />
          <span>
            {aspect.label}
            <small>{aspect.detail}</small>
          </span>
        </button>
      ))}
    </div>
  );
}

export default function TemplatePicker({ aspect, value, onChange }) {
  const previews = useMemo(
    () => TEMPLATES.map((template) => ({ ...template, items: buildTemplate(template.key, aspect) })),
    [aspect]
  );

  return (
    <div className="mb-templates" role="radiogroup" aria-label="Layout">
      {previews.map((template) => (
        <button
          key={template.key}
          type="button"
          role="radio"
          aria-checked={value === template.key}
          className={value === template.key ? "active" : ""}
          onClick={() => onChange(template.key)}
        >
          <BoardCanvas
            board={{ aspect, background: "#ffffff", items: template.items }}
            compact
            showPlaceholders
          />
          <span>{template.label}</span>
        </button>
      ))}
    </div>
  );
}
